import {
  Component, input,
} from '@angular/core';
import { EventInfo } from 'in-time-core';
import { CategorySectionHeaderComponent } from '../category-section-header/category-section-header.component';
import { EventCardComponent } from '../event-card/event-card.component';
import { SmallEventCardComponent } from '../small-event-card/small-event-card.component';

@Component({
  standalone: true,
  selector: 'app-responsive-event-list',
  templateUrl: './responsive-event-list.component.html',
  imports: [
    CategorySectionHeaderComponent, EventCardComponent, SmallEventCardComponent,
  ]
})
export class ResponsiveEventListComponent {
  public readonly events = input.required<EventInfo[]>();
  public readonly canOverrideEventLink = input<boolean>();
}
